import { EMPTY_UUID } from './radar';

export const getLevelTypes = (skillLevels) => {
  return skillLevels.map(level => level.levelType);
};

export const getDisplayName = (levelId, skillLevels) => {
  if (!skillLevels || skillLevels.length === 0) {
    return 'Unknown';
  }

  const level = skillLevels.find(l => l.levelId === levelId);
  return level ? level.displayName : 'Unknown';
};

export const getColor = (levelId, skillLevels) => {
  if (!skillLevels || skillLevels.length === 0) {
    return '#CCCCCC';
  }

  const level = skillLevels.find(l => l.levelId === levelId);
  return level ? level.color : '#CCCCCC';
};

export const getDescription = (levelId, skillLevels) => {
  const level = skillLevels.find(l => l.levelId === levelId);
  return level ? level.defaultDescription : '';
};

export const getNumericLevel = (levelId, skillLevels) => {
  const level = skillLevels.find(l => l.levelId === levelId);
  return level ? level.level : 0;
};

// used in the reports
export const getLevelDisplayName = (numericLevel, skillLevels) => {
  if (!skillLevels || skillLevels.length === 0) {
    return 'N/A';
  }

  const level = skillLevels.find(l => l.level === numericLevel);
  return level ? level.displayName : 'N/A';
};

export const getDefaultLevelId = (skillLevels) => {
  if (!skillLevels || skillLevels.length === 0) {
    return EMPTY_UUID;
  }
  
  // Find the level with the minimum numeric value
  const minLevel = skillLevels.reduce((min, level) => 
    level.level < min.level ? level : min, 
    skillLevels[0]
  );
  
  return minLevel.levelId;
};